import React from "react";
import { TSessionContext } from "../utils/types";

const SessionContext = React.createContext<TSessionContext | null>(null);

export default SessionContext;
